import * as React from 'react'
import moment from 'moment'
import { DatePicker as AnDatePicker } from 'antd'
import './datePickerStyles.css';
import fieldProps from './fieldProps'
import {CalendarIcon} from "../../../../config/icons";

const dateFormat = 'DD/MM/YYYY'
const formater = (m, format, convertToString) => convertToString ? m.format(format) : m.unix()

@fieldProps
export default class Datepicker extends React.Component {
  render() {
    const { onChange, format = 'YYYY-MM-DD', value, disabled, convertToString = false } = this.props

    return (
      <AnDatePicker
        suffixIcon={<CalendarIcon />}
        className={"date-picker-left"}
        onChange={m => onChange(m ? formater(m, format, convertToString) : m)}
        value={value ? moment(value, format === 'X' ? 'X': undefined) : null}
        format={dateFormat}
        disabled={disabled}
        placeholder={''}
      />
    )
  }
}